export default {
  fixed: 'Fixed',
  variable: 'Variable',
};
